var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"info_btn",on:{"click":function($event){return _vm.addImg($event)}}},[_vm._v(" "+_vm._s(_vm.navName)+" "),_c('input',{staticStyle:{"display":"none"},attrs:{"type":"file","accept":_vm.acc,"capture":"camera"},on:{"change":function($event){return _vm.beforeUpload($event)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }